/**
 * AddBody — renders the expanded detail for an `add` version.
 *
 * Backend audit (Commit 4 audit step):
 *   diff = { kind: 'add', agent_name, array_key, id_field, record_id,
 *            added_record }
 *
 *   - Verified at record_operations.py:621-633 (single-record add)
 *   - VersionRecord.agent_name carries the source agent so MiniRow
 *     picks the right column layout.
 *
 * Render: caption (record_id + collection key) + a single MiniRow
 * tinted green for the added record. No mock-only fields touched.
 */
import React from 'react';
import { VersionRecord, AddDiff } from '../../state/types';
import MiniRow from '../MiniRow/MiniRow';
import styles from './operationBodies.module.css';

interface AddBodyProps {
  version: VersionRecord;
}

export default function AddBody({ version }: AddBodyProps) {
  const diff = version.diff as AddDiff | null;
  if (!diff || diff.kind !== 'add' || !version.agent_name) return null;

  return (
    <div className={styles.body}>
      <div className={styles.detailHeader}>
        <span>
          Added <code>{diff.record_id}</code>
        </span>
        <span>
          Collection <code>{diff.array_key}</code>
        </span>
      </div>
      <MiniRow
        agentName={version.agent_name}
        record={diff.added_record}
        state="added"
      />
    </div>
  );
}
